export default function Empty() {
  return null;
}
